﻿import { Kb3dModel } from '../decorators/kb3d-decorator';
import { IAmbientOcclusionFeature } from '../kb3d-models';
import { Token } from '../token';
import { eMeshChangeTypes, Feature } from './feature';

@Kb3dModel({
    token: Token.AmbientOcclusionFeature,
})
export class AmbientOcclusionFeature extends Feature implements IAmbientOcclusionFeature {
    static _affects = new Set([eMeshChangeTypes.Colors]);
    static _affectedBy = new Set([
        eMeshChangeTypes.VertexIndices,
        eMeshChangeTypes.VertexPositions,
        eMeshChangeTypes.Colors,
    ]);

    radius: number;
    neighborThreshold: number;
    maxDarken: number;
    sampleStep: number;
    includeSelfOcclusion: boolean;
}
